<div class="checkbox-container">
  <app-base-label
    class="mb-3"
    *ngIf="!!label"
    [required]="checkRequiredField()"
    [label]="label"
    [labelOneLine]="labelOneLine"
    [iconLabelTooltip]="iconLabelTooltip"
  >
  </app-base-label>
  <div
    [class]="'flex ' + optionsContainerClass"
    [ngClass]="{ 'flex-column': direction === 'column' }"
  >
    <div class="input-container mr-4" *ngFor="let item of options">
      <p-checkbox
        [name]="item.value"
        [(ngModel)]="selected"
        [value]="item.value"
        [inputId]="item.value"
        [disabled]="item?.disabled || disabled"
        (onChange)="handleChange($event, item.value)"
      >
      </p-checkbox>
      <label *ngIf="!!item.label" [for]="item.value" class="fz-14_lh-16"
        >{{ item.label | translate }}
        <span class="asterisk" *ngIf="item.required">*</span></label
      >
    </div>
  </div>
  <app-base-label
    *ngIf="checkInvalidField()"
    [label]="errorMessage"
    mode="error"
  >
  </app-base-label>
</div>
